export const BASE_URL = (process.env.NODE_ENV === 'production') ? 'https://onroad-api.vercel.app/': '' ;
export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const PAYPAL_URL = '/api/config/paypal';
export const PREORDERS_URL = '/api/preorders';
